import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";

const ENDPOINT = "/organizations";

export class DeleteOrganizationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "delete";
    data: DeleteOrganizationReqData;

    constructor(data: DeleteOrganizationReqData) {
        super();
        this.data = data;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand(this.data);
        return new ServiceResponseData(res);
    }
}

export class DeleteOrganizationReqData {
    folderId: number;

    constructor(folderId: number) {
        this.folderId = folderId;
    }
}
